export const SCOPE = 'filterContainer';
export const ADD_AND_RULE = `${SCOPE}/ADD_AND_RULE`;
export const ADD_OR_RULE = `${SCOPE}/ADD_OR_RULE`;
export const UPDATE_OR_RULE = `${SCOPE}/UPDATE_OR_RULE`;
export const SAVE_FILTER = `${SCOPE}/SAVE_FILTER`;
export const EDIT_FILTER = `${SCOPE}/EDIT_FILTER`;
export const APPLY_FILTER = `${SCOPE}/APPLY_FILTER`;
export const RESET_FILTER = `${SCOPE}/RESET_FILTER`;
export const UPDATE_ACTIVE_TAB = `${SCOPE}/UPDATE_ACTIVE_TAB`;
export const DELETE_OR_RULE = `${SCOPE}/DELETE_OR_RULE`;
export const CREATE_FILTER = `${SCOPE}/CREATE_FILTER`;
export const CREATE_AND_APPLY = `${SCOPE}/CREATE_AND_APPLY`;
export const UPDATE_FILTER = `${SCOPE}/UPDATE_FILTER`;
export const UPDATE_AND_APPLY = `${SCOPE}/UPDATE_AND_APPLY`;
export const START_SAVING_CHANGES = `${SCOPE}/START_SAVING_CHANGES`;
export const DONE_SAVING_CHANGES = `${SCOPE}/DONE_SAVING_CHANGES`;
export const UPDATE_META = `${SCOPE}/UPDATE_META`;
export const GET_FILTERS = `${SCOPE}/GET_FILTERS`;
export const DONE_GETTING_FILTERS = `${SCOPE}/DONE_GETTING_FILTERS`;
export const UPDATE_SELECTED_FILTERS = `${SCOPE}/UPDATE_SELECTED_FILTERS`;
export const UPDATE_FILTER_CONDITIONS = `${SCOPE}/UPDATE_FILTER_CONDITIONS`;
export const CHANGE_FILTER_CONTAINER_VISIBILITY = `${SCOPE}/CHANGE_FILTER_CONTAINER_VISIBILITY`;
export const RESET_DRILL_DOWN = `${SCOPE}/RESET_DRILL_DOWN`;
export const LOAD_DEFAULT_FILTERS = `${SCOPE}/LOAD_DEFAULT_FILTERS`;
export const SET_DEFAULT_FILTERS = `${SCOPE}/SET_DEFAULT_FILTERS`;
export const CLEAR_FILTER_CACHE = `${SCOPE}/CLEAR_FILTER_CACHE`;
export const UPDATE_CONTENT_FILTER = `${SCOPE}/UPDATE_CONTENT_FILTER`;
export const SET_INITIAL_RULE = `${SCOPE}/SET_INITIAL_RULE`;
